/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { z } from "zod";

export const patchApiFeedbacksIdStatusPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор чата")
    })

/**
 * @description Статус изменен
 */
export const patchApiFeedbacksIdStatus200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации
 */
export const patchApiFeedbacksIdStatus400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const patchApiFeedbacksIdStatus401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const patchApiFeedbacksIdStatus403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не найден | Сообщение не найдено | Чат не найден
 */
export const patchApiFeedbacksIdStatus404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const patchApiFeedbacksIdStatus500Schema = z.lazy(() => badResponseModelSchema)

export const patchApiFeedbacksIdStatusMutationResponseSchema = z.lazy(() => patchApiFeedbacksIdStatus200Schema)